export default function select() {
  $(document).ready(function() {
    // Toggle .open class when clicking on the container
    $('.select .container-select').click(function(e) {
      // Close all other open selects
      $('.select .container-select')
        .not(this)
        .removeClass('open')
        .siblings('.container-select-list')
        .removeClass('open')

      // Toggle the current select
      $(this).toggleClass('open')
      $(this)
        .siblings('.container-select-list')
        .toggleClass('open')

      e.stopPropagation() // Prevents the document click event from firing
    })

    // Change the container text and remove .open class when an option is selected
    $('.select .container-select-list li.option').click(function(e) {
      var selectedText = $(this).text()
      $(this)
        .closest('.select')
        .find('.container-select span')
        .text(selectedText)
      $('.select .container-select').removeClass('open')
      $('.select .container-select-list').removeClass('open')

      // Store the selected value
      $(this)
        .closest('.select')
        .find('.container-select')
      $(this)
        .closest('.container-select-block')
        .find('input.select-input')
        .val(selectedText)
        .trigger('change')
        .attr('value', selectedText)
      e.stopPropagation()
    })

    // Close the dropdown when clicking outside
    $(document).click(function() {
      $('.select .container-select').removeClass('open')
      $('.select .container-select-list').removeClass('open')
    })
  })
}
